import { useSuspenseQuery } from '@tanstack/react-query';
import { createFileRoute, Link } from '@tanstack/react-router';
import { Button } from '@upme/ui/components/button';
import { canEditGlobalCatalog } from '../../../features/auth/admin-capabilities';
import { useAuth } from '../../../features/auth/auth-context';
import { ServiceCategoriesTable } from '../../../features/service-categories/components/service-categories-table';
import { listServiceCategoriesOptions } from '../../../features/service-categories/queries';
import { PageHeader } from '../../../shared/components/page-header';

export const Route = createFileRoute('/_authenticated/service-categories/')({
  loader: ({ context }) => context.queryClient.ensureQueryData(listServiceCategoriesOptions()),
  component: ServiceCategoriesIndexPage,
});

function ServiceCategoriesIndexPage() {
  const { data: categories } = useSuspenseQuery(listServiceCategoriesOptions());
  const { adminRoles } = useAuth();
  const canEdit = canEditGlobalCatalog(adminRoles);
  return (
    <div>
      <PageHeader
        title="Категории услуг"
        description="Справочник категорий, к которым привязываются услуги."
        actions={
          canEdit ? (
            <Button asChild>
              <Link to="/service-categories/new">Новая категория</Link>
            </Button>
          ) : null
        }
      />
      {!canEdit && (
        <p className="text-sm text-muted-foreground mb-4">Редактировать категории может только SUPERADMIN.</p>
      )}
      <ServiceCategoriesTable categories={categories} />
    </div>
  );
}
